(function () {
  const CONFIG = {
    version: "RM-1.0",
    offer: {
      price: 42,
      bagCount: 2,
      bagOunces: 16,
      freeShipping: true,
      replacementCount: 1,
      subscriptionCredit: 10,
      subscriptionCreditDays: 14
    },
    starterPackHandle: "starter-pack",
    eligibleRoastHandles: [
      "pure-gold-no-2-light-roast",
      "pure-gold-no-4-medium-roast",
      "pure-gold-no-6-dark-roast",
      "pure-gold-melange",
      "sweet-dreams-decaf"
    ],
    questions: [
      {
        id: "cup",
        text: "What sounds best in your cup?",
        max: 1,
        options: [
          ["bright", "Bright, lively and clean"],
          ["balanced", "Balanced, smooth and flavorful"],
          ["rich", "Rich, chocolate-forward and full-bodied"],
          ["dark", "Bold, dark and intense"],
          ["espresso", "I mostly drink espresso"],
          ["surprise", "Surprise me"]
        ]
      },
      {
        id: "boldness",
        text: "How bold do you like your coffee?",
        max: 1,
        options: [
          ["light", "Light"],
          ["medium", "Medium"],
          ["medium_dark", "Medium-dark"],
          ["dark", "Dark"],
          ["max", "As bold as you've got"]
        ]
      },
      {
        id: "flavors",
        text: "Which flavors pull you in?",
        max: 2,
        options: [
          ["chocolate", "Chocolate"],
          ["caramel", "Caramel"],
          ["fruit", "Fruit"],
          ["nutty", "Nutty/toasted"],
          ["citrus", "Bright/citrus"],
          ["deep", "Deep roasted flavors"]
        ]
      },
      {
        id: "brew",
        text: "How do you usually brew?",
        max: 1,
        options: [
          ["drip", "Automatic drip"],
          ["pour_over", "Pour-over"],
          ["french_press", "French press"],
          ["espresso", "Espresso"],
          ["moka", "Moka pot"],
          ["aeropress", "AeroPress"],
          ["keurig", "Keurig/reusable pod"],
          ["cold_brew", "Cold brew"],
          ["other", "Other"]
        ]
      },
      {
        id: "drink",
        text: "How do you usually drink it?",
        max: 1,
        options: [
          ["black", "Black"],
          ["cream", "Splash of milk/cream"],
          ["milk", "Milk-forward"],
          ["sweet", "Sweetened"],
          ["depends", "It depends on the day"]
        ]
      },
      {
        id: "caffeine",
        text: "Do you want regular coffee or decaf?",
        max: 1,
        options: [
          ["caffeinated", "Regular coffee"],
          ["decaf", "Decaf only"],
          ["either", "Either is fine"]
        ]
      },
      {
        id: "style",
        text: "How should we prepare your coffee?",
        max: 1,
        options: [
          ["Whole bean", "Whole bean"],
          ["Ground", "Ground"]
        ]
      }
    ]
  };

  const state = {
    step: 0,
    answers: {},
    starterPack: null,
    roasts: (window.RoastMatchEngine?.products || []).slice(),
    result: null
  };

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, roast_match: detail || {} });
    if (window.fbq) window.fbq("trackCustom", eventName, detail || {});
    if (window.ttq && window.ttq.track) window.ttq.track(eventName, detail || {});
  }

  function persistUtms() {
    const params = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const current = JSON.parse(sessionStorage.getItem("rm_utms") || "{}");
    keys.forEach((key) => {
      if (params.has(key)) current[key] = params.get(key);
    });
    sessionStorage.setItem("rm_utms", JSON.stringify(current));
  }

  async function getProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`Could not load ${handle}`);
    return response.json();
  }

  async function loadStoreData() {
    try {
      state.starterPack = await getProduct(CONFIG.starterPackHandle);
    } catch (error) {
      state.starterPack = null;
    }

    const productResults = await Promise.allSettled(CONFIG.eligibleRoastHandles.map(getProduct));
    const fetched = productResults
      .filter((result) => result.status === "fulfilled")
      .map((result) => result.value);

    if (fetched.length) {
      state.roasts = (window.RoastMatchEngine?.products || []).map((roast) => {
        const product = fetched.find((item) => item.handle === roast.handle);
        if (!product) return { ...roast, available: false };
        return {
          ...roast,
          id: product.id,
          displayName: product.title,
          image: product.featured_image,
          available: product.available !== false,
          product
        };
      }).filter((roast) => roast.available);
    }
  }

  function makeResult() {
    const recommendation = window.RoastMatchEngine.recommend(state.answers, { products: state.roasts });
    const byId = new Map(state.roasts.map((roast) => [roast.id, roast]));
    const primary = byId.get(recommendation.primary.roastId);
    const secondary = recommendation.secondary ? byId.get(recommendation.secondary.roastId) : primary;
    state.result = { primary, secondary, recommendation };
    sessionStorage.setItem("rm_result", JSON.stringify({ answers: state.answers, result: state.result }));
    track("roast_quiz_completed", {
      primary: primary.displayName,
      secondary: secondary.displayName,
      version: recommendation.scoringVersion,
      confidence: recommendation.primary.confidence
    });
  }

  function brewRecipe() {
    const brew = state.answers.brew || "drip";
    const style = state.answers.style || "Whole bean";
    const map = {
      drip: ["Automatic drip", "Medium", "22 g", "12 oz", "195-205 F", "Machine cycle"],
      pour_over: ["Pour-over", "Medium-fine", "22 g", "350 g", "200-205 F", "2:45-3:30"],
      french_press: ["French press", "Coarse", "30 g", "450 g", "200 F", "4:00"],
      espresso: ["Espresso", "Fine", "18 g", "36 g out", "Machine setpoint", "25-32 sec"],
      moka: ["Moka pot", "Fine-medium", "Fill basket level", "Fill to valve", "Hot water start", "Until flow lightens"],
      aeropress: ["AeroPress", "Medium-fine", "15 g", "240 g", "195-205 F", "1:30-2:00"],
      keurig: ["Reusable pod", "Medium", "Fill pod without packing", "8-10 oz", "Machine setpoint", "Machine cycle"],
      cold_brew: ["Cold brew", "Coarse", "80 g", "640 g", "Room temp", "12-16 hr"],
      other: ["Your method", style === "Ground" ? "Standard ground" : "Grind before brewing", "Start at 1:16", "Filtered water", "195-205 F", "Adjust by taste"]
    };
    return map[brew] || map.drip;
  }

  function renderQuiz() {
    const shell = $("#rm-quiz-shell");
    if (!shell) return;
    const question = CONFIG.questions[state.step];
    const selected = state.answers[question.id] || [];
    const selectedValues = Array.isArray(selected) ? selected : [selected];
    shell.innerHTML = `
      <div class="rm-progress" aria-live="polite">${state.step + 1} of ${CONFIG.questions.length}</div>
      <h2 class="rm-question">${question.text}</h2>
      <div class="rm-options" role="group" aria-label="${question.text}">
        ${question.options.map(([value, label]) => `
          <button class="rm-option" type="button" data-value="${value}" aria-pressed="${selectedValues.includes(value)}">${label}</button>
        `).join("")}
      </div>
      <div class="rm-quiz-nav">
        <button class="rm-button secondary" type="button" data-back ${state.step === 0 ? "disabled" : ""}>Back</button>
        <button class="rm-button" type="button" data-next ${selectedValues.length ? "" : "disabled"}>${state.step === CONFIG.questions.length - 1 ? "See My Roast" : "Next"}</button>
      </div>
    `;
    $$(".rm-option", shell).forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.value;
        if (question.max === 1) {
          state.answers[question.id] = value;
        } else {
          const current = Array.isArray(state.answers[question.id]) ? state.answers[question.id].slice() : [];
          const index = current.indexOf(value);
          if (index >= 0) current.splice(index, 1);
          else if (current.length < question.max) current.push(value);
          state.answers[question.id] = current;
        }
        track("roast_quiz_answered", { question: question.id });
        renderQuiz();
      });
    });
    $("[data-back]", shell).addEventListener("click", () => {
      if (state.step > 0) {
        state.step -= 1;
        renderQuiz();
      }
    });
    $("[data-next]", shell).addEventListener("click", () => {
      if (state.step < CONFIG.questions.length - 1) {
        state.step += 1;
        renderQuiz();
      } else {
        makeResult();
        renderResult();
        if (!$("#rm-popup")) $("#rm-result")?.scrollIntoView({ behavior: "smooth" });
      }
    });
  }

  function renderResult() {
    const target = $("#rm-result");
    if (!target || !state.result) return;
    const [method, grind, coffee, water, temp, time] = brewRecipe();
    const primary = state.result.primary;
    const secondary = state.result.secondary;
    const explanation = state.result.recommendation.explanationData;
    const secondaryStrategy = state.result.recommendation.secondaryStrategy === "adjacent-exploration"
      ? (state.result.recommendation.explorationDimension ? `one step ${state.result.recommendation.explorationDimension}` : "adjacent exploration")
      : "close match";
    target.hidden = false;
    target.innerHTML = `
      <div class="rm-wrap rm-result-grid">
        <div class="rm-result">
          <p class="rm-eyebrow">Your Roast Match</p>
          <h2>${primary.displayName}</h2>
          <p>${explanation.primary.text}</p>
          <h3>Your Second Bag</h3>
          <p><strong>${secondary.displayName}</strong></p>
          <p>${explanation.secondary.text}</p>
          <h3>Your Personal Brew Starting Point</h3>
          <p><strong>Brew method:</strong> ${method}<br><strong>Roast:</strong> ${primary.displayName}<br><strong>Grind:</strong> ${grind}<br><strong>Coffee:</strong> ${coffee}<br><strong>Water:</strong> ${water}<br><strong>Temperature:</strong> ${temp}<br><strong>Brew time:</strong> ${time}</p>
          <p>If it tastes too bitter, grind a little coarser or shorten brew time. If it tastes thin or sour, grind a little finer or brew a little longer.</p>
        </div>
        <div class="rm-builder" id="rm-builder">
          <h2>Your $42 Roast Match Starter Pack</h2>
          <label>Bag one <select class="rm-select" id="rm-bag-one">${roastOptions(primary.handle)}</select></label>
          <label>Bag two <select class="rm-select" id="rm-bag-two">${roastOptions(secondary.handle)}</select></label>
          <label>Style <select class="rm-select" id="rm-style"><option ${state.answers.style === "Whole bean" ? "selected" : ""}>Whole bean</option><option ${state.answers.style === "Ground" ? "selected" : ""}>Ground</option></select></label>
          <p>2 x 16 oz bags<br>Free shipping<br>Roast Match Guarantee included</p>
          <div class="rm-total"><span>Total</span><span>$42</span></div>
          <button class="rm-button" type="button" id="rm-add">Get My Roast Match - $42</button>
          <div class="rm-status" id="rm-status" role="status" aria-live="polite"></div>
        </div>
      </div>
    `;
    $("#rm-add").addEventListener("click", addStarterPack);
    track("roast_match_viewed", { primary: primary.displayName, secondary: secondary.displayName, secondary_strategy: secondaryStrategy });
  }

  function humanizeAnswers() {
    const parts = [];
    if (state.answers.cup) parts.push(state.answers.cup.replace("_", " "));
    if (state.answers.boldness) parts.push(`${state.answers.boldness.replace("_", "-")} body`);
    if (state.answers.flavors?.length) parts.push(state.answers.flavors.join(" and "));
    return parts.join(", ") || "a balanced cup";
  }

  function roastOptions(selectedHandle) {
    return state.roasts.map((roast) => `<option value="${roast.handle}" data-label="${roast.starterPackOptionLabel}" ${roast.handle === selectedHandle ? "selected" : ""}>${roast.displayName}</option>`).join("");
  }

  function findStarterVariant(bagOneLabel, bagTwoLabel, style) {
    if (!state.starterPack || !state.starterPack.variants) return null;
    const beanStyle = style === "Ground" ? "Pre-ground" : "Whole Bean";
    return state.starterPack.variants.find((variant) =>
      variant.available &&
      variant.option1 === bagOneLabel &&
      variant.option2 === bagTwoLabel &&
      variant.option3 === beanStyle
    ) || null;
  }

  async function addStarterPack() {
    const status = $("#rm-status");
    const bagOneSelect = $("#rm-bag-one");
    const bagTwoSelect = $("#rm-bag-two");
    const style = $("#rm-style").value;
    const bagOneRoast = state.roasts.find((roast) => roast.handle === bagOneSelect.value);
    const bagTwoRoast = state.roasts.find((roast) => roast.handle === bagTwoSelect.value);
    const bagOne = bagOneRoast?.displayName || bagOneSelect.value;
    const bagTwo = bagTwoRoast?.displayName || bagTwoSelect.value;
    const variant = findStarterVariant(bagOneRoast?.starterPackOptionLabel, bagTwoRoast?.starterPackOptionLabel, style);
    if (!variant) {
      status.textContent = "Starter Pack option could not be matched. Use the install notes to verify the Shopify product options before publishing.";
      return;
    }
    track("starter_pack_customized", { bag_one: bagOne, bag_two: bagTwo, style });
    const properties = {
      "Roast Match Quiz": "Completed",
      "Recommended Roast": state.result.primary.displayName,
      "Second Recommendation": state.result.secondary.displayName,
      "Bag One": bagOne,
      "Bag Two": bagTwo,
      "Bean Style": style,
      "Brew Method": (state.answers.brew || "drip").replace("_", " "),
      "Quiz Version": CONFIG.version,
      "Match ID": makeMatchId()
    };
    const utms = JSON.parse(sessionStorage.getItem("rm_utms") || "{}");
    Object.keys(utms).forEach((key) => {
      properties[key] = utms[key];
    });
    status.textContent = "Adding your Starter Pack...";
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variant.id, quantity: 1, properties })
    });
    if (!response.ok) {
      status.textContent = "Cart could not be updated. Please try again.";
      return;
    }
    track("starter_pack_added_to_cart", { bag_one: bagOne, bag_two: bagTwo, style });
    window.location.href = "/cart";
  }

  function makeMatchId() {
    const raw = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    return `RM-${btoa(raw).replace(/[^A-Z0-9]/gi, "").slice(0, 8).toUpperCase()}`;
  }

  function setupSticky() {
    const sticky = $("#rm-sticky");
    const heroButton = $("#rm-hero-cta");
    if (!sticky || !heroButton) return;
    const observer = new IntersectionObserver((entries) => {
      sticky.classList.toggle("visible", !entries[0].isIntersecting && !$("#rm-result:not([hidden])"));
    });
    observer.observe(heroButton);
  }

  function openPopup() {
    const popup = $("#rm-popup");
    if (!popup) return false;
    popup.hidden = false;
    document.documentElement.classList.add("rm-popup-open");
    $(".rm-popup-panel", popup)?.focus();
    track("roast_quiz_popup_opened", { version: CONFIG.version });
    return true;
  }

  function closePopup() {
    const popup = $("#rm-popup");
    if (!popup) return;
    popup.hidden = true;
    document.documentElement.classList.remove("rm-popup-open");
  }

  function setupPopup() {
    const popup = $("#rm-popup");
    if (!popup) return;
    $$("[data-rm-close]", popup).forEach((button) => button.addEventListener("click", closePopup));
    popup.addEventListener("click", (event) => {
      if (event.target === popup) closePopup();
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !popup.hidden) closePopup();
    });
  }

  function bindCtas() {
    $$("[data-rm-start]").forEach((button) => {
      button.addEventListener("click", () => {
        track("roast_quiz_started", { version: CONFIG.version });
        if (!openPopup()) $("#rm-quiz")?.scrollIntoView({ behavior: "smooth" });
      });
    });
  }

  async function init() {
    persistUtms();
    await loadStoreData();
    setupPopup();
    bindCtas();
    setupSticky();
    renderQuiz();
    const visual = $("#rm-product-img");
    const imageRoast = state.roasts.find((roast) => roast.image);
    if (visual && imageRoast?.image) visual.src = imageRoast.image;
    track("PAGE_VIEW", { page: "roast-match" });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
